import { Fragment, useContext, useEffect, useState } from "react";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { ConvertToFloat } from "../../../Layout/Common/common";
import { GlobalContext } from "../../../Context/GlobalContext";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { ToolbarContainer } from "../toolbarContainer";
import { PriceTablePopup } from "../RightOptions/priceTablePopup";
import { ProductStockStatusContainer } from "../../../Layout/Common/productStockStatusContainer";
import { handleStockStatus } from "../../../utils/stockStatus";
import { useAuth } from "../../../Context/AuthContext";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { isPlainLeftClick, useProductOverlay } from "../productOverlay/productOverlayContext";
import { ProductLink } from "../../../Layout/Common/productLink";

const FIXED_POPUP_CONFIG = { strategy: "fixed", placement: "bottom-end" };

export const FamilyProductRow = ({ row, feature, attributeColumns = [] }) => {
  const [product, setProduct] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [productStock, setProductStock] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { getStockStatus } = useGlobalFunction();
  const { isBrowseOnly } = useAuth();
  const overlay = useProductOverlay();
  const openInOverlay = (event) => {
    if (!overlay?.openProduct || !isPlainLeftClick(event)) return;
    event.preventDefault();
    overlay.openProduct(product.sku ?? product.productCode);
  };

  useEffect(() => {
    if (row) {
      setProduct(row);
      // fetchStockStatus(row.productId);
      if (row.stockStatus) {
        setProductStock(handleStockStatus(row.stockStatus));
      }
    }
  }, [row]);

  const fetchStockStatus = async (productId) => {
    let res = await getStockStatus(productId ?? 0);
    if (res) setProductStock(res);
  };

  useEffect(() => {
    if (!row) return;
    const products = globalcontext?.CartItem?.cartItem;
    const match = Array.isArray(products)
      ? products.find((item) => String(item.prod_id) == String(row.productId))
      : null;
    setCartItem({ prod_id: row.productId, qty: match && match.qty ? match.qty : 0 });
  }, [globalcontext.CartItem, row]);

  if (!product) return null;

  const attributeValue = (name) => {
    if (!Array.isArray(feature)) return "";
    const match = feature.find((item) => item.attributeName === name);
    return match ? match.attributeValue : "";
  };
  return (
    <tr data-id={product.productId}>
      <td className="img-cell sticky-col sticky-img" data-label="" style={{ minWidth: 100 }}>
        <ProductLink to={product.link} className="family-img-thumbnail" onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
          <ImageWithDefault src={product.prodImage} className="img-fluid" alt="product image" />
        </ProductLink>
      </td>
      <td className="sticky-col sticky-code" data-label="Description">
        <h6 className="product-title m-0">
          <ProductLink to={product.link} onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
            {product.productCode}
          </ProductLink>
        </h6>
      </td>
      {attributeColumns.map((name) => (
        <td key={name} data-label={name}>
          <span dangerouslySetInnerHTML={{ __html: attributeValue(name) }} />
        </td>
      ))}
      <td className="sticky-col sticky-cost" data-label="Cost">
        $ {ConvertToFloat(product.price)}
        {/* <div className="price-block">$ {ConvertToFloat(product.price)}</div>
        <span className="proAvailablity">
          {productStock ? (
            <ProductStockStatusContainer params={productStock} stockStatus={stockStatusRaw} />
          ) : (
            <span className="cc-pro-available" dangerouslySetInnerHTML={{ __html: stockStatusRaw }} />
          )}
        </span> */}
        <PriceTablePopup params={product} mode={2} stockStatus={productStock} popperConfig={FIXED_POPUP_CONFIG} />
      </td>
      <td className="sticky-col sticky-buy text-end" data-label="Buy">
        <div>
          <div className="row-products-info justify-content-end">
            <div className="product-adding-icons rowProducts-addingIcons d-none">
              <ToolbarContainer product={product} cartItem={cartItem} showPriceTable={false} />
            </div>

            {productStock && !isBrowseOnly && (
              <Fragment>
                {productStock.isShowBuy == true ? (
                  <QuantityStripper
                    wrapperClass="flex-nowrap"
                    prd={cartItem}
                    params={{
                      code: product.productCode,
                      desc: product.description,
                      img: product.prodImage,
                    }}
                  />
                ) : (
                  <ProductStockStatusContainer params={productStock} stockStatus={productStock} />
                )}
              </Fragment>
            )}
          </div>
          <ProductLink
            to={product.link}
            className="fs-14 text-link text-decoration-underline d-block"
            onClick={openInOverlay}
            data-overlay-skip={overlay?.openProduct ? "" : undefined}
          >
            More Info
          </ProductLink>
        </div>
      </td>
    </tr>
  );
};
